module.exports = __webpack_public_path__ + "static/assets/c7b3e36597c907db17adf60999457420.png";